import React, { useEffect, useState } from 'react';
import Firebase from "../../../Firebase/Firebase";
import { Form, Input, message, Select } from "antd";
import { Button } from "evergreen-ui";
import { useListVals } from "../../../Firebase/databaseHooks";
import FireFetch from "../../../Firebase/FireFetch";
import { getDatabase, ref, update } from "firebase/database";
import { useAuth } from "../../../AuthContext/AuthContext";

var db = getDatabase(Firebase);

const EditQuiz = (props) => {
	const { canAccessModule } = useAuth();
	const canUpdateQuiz = props.canUpdateQuiz ?? canAccessModule("QUIZZES", "update");
	const [categoryArray] = useListVals(ref(db, "talmidsdb/categories"))
	const [lessonArray] = useListVals(ref(db, "talmidsdb/lessons"))
	const [languageArray] = useListVals(ref(db, "talmidsdb/languages"))
	const [quiz, setQuiz] = useState(props.quiz);
	const [form] = Form.useForm();
	const [isChanged, setIsChanged] = useState(false);

	useEffect(() => {
		setQuiz(props.quiz);
		form.setFieldsValue({
			title: props.quiz.title,
			lesson: props.quiz.lessonID,
			category: props.quiz.categoryID,
			language: props.quiz.languageID,
		});
		setIsChanged(false);
	}, [props.quiz, form]);

	const initialValues = {
		title: quiz.title,
		lesson: quiz.lessonID,
		category: quiz.categoryID,
		language: quiz.languageID,
	};

	const handleFormChange = (_, allValues) => {
		const changed = Object.keys(initialValues).some(
			key => initialValues[key] !== allValues[key]
		);
		setIsChanged(changed);
	};

	const editQuiz = (values) => {
		if (!canUpdateQuiz) {
			message.error("You do not have permission to update quizzes.");
			return;
		}

		const object = {
			title: values.title,
			lessonID: values.lesson,
			categoryID: values.category,
			languageID: values.language,
		};
		update(ref(db, "talmidsdb/quizzes/" + quiz.id), object)
			.then(() => {
				FireFetch.addLog("quizzes", quiz.id, "Edit");
				message.success('Quiz Edited Successfully!');
				props.next();
			})
			.catch(() => {
				message.error('Unable to edit quiz!');
			});
	};

	return (
		<>
			<Form
				form={form}
				onFinish={editQuiz}
				onValuesChange={handleFormChange}
				className="p-3 font-Nunito"
				initialValues={initialValues}
			>
				<Form.Item label="Quiz Title" name="title" rules={[{ required: true, message: 'Please input title!' }]}>
					<Input placeholder="enter quiz title" id="title" disabled={!canUpdateQuiz} />
				</Form.Item>
				<Form.Item label="Lesson" name="lesson" rules={[{ required: true, message: 'Please select lesson!' }]}>
					<Select placeholder="Select quiz lesson" disabled={!canUpdateQuiz}>
						{lessonArray?.map((item, index) => (
							<Select.Option key={index} value={item.id}>{item.lessonName}</Select.Option>
						))}
					</Select>
				</Form.Item>
				<Form.Item label="Category" name="category" rules={[{ required: true, message: 'Please select category!' }]}>
					<Select placeholder="Select quiz category" disabled={!canUpdateQuiz}>
						{categoryArray?.map((item, index) => (
							<Select.Option key={index} value={item.id}>{item.name}</Select.Option>
						))}
					</Select>
				</Form.Item>
				<Form.Item label="Language" name="language" rules={[{ required: true, message: 'Please input language!' }]}>
					<Select placeholder="Select quiz language" disabled={!canUpdateQuiz}>
						{languageArray?.map((item, index) => (
							<Select.Option key={index} value={item.id}>{item.languageName}</Select.Option>
						))}
					</Select>
				</Form.Item>
				<Button
					id="btnSubmit"
					appearance="primary"
					htmlType="submit"
					disabled={!canUpdateQuiz || !isChanged}
				>
					Save
				</Button>
			</Form>
		</>
	);
};

export default EditQuiz;
